/**
 * RMFF Tabs Widget Scripts
 */
export function tabsWidgetScripts() {
    // Only run on frontend, not in Elementor editor
    if (document.body.classList.contains('elementor-editor-active')) {
        return;
    }
    // Initialize tabs functionality
    initTabs();
}
function initTabs() {
    var tabWidgets = document.querySelectorAll('.rmff-tabs-widget');
    tabWidgets.forEach(function (widget) {
        var tabButtons = widget.querySelectorAll('.rmff-tab-button');
        var tabContents = widget.querySelectorAll('.rmff-tab-content');
        tabButtons.forEach(function (button, buttonIndex) {
            button.addEventListener('click', function () {
                // Remove active class from all buttons and contents
                tabButtons.forEach(function (btn) { return btn.classList.remove('active'); });
                tabContents.forEach(function (content) {
                    content.classList.remove('active');
                    // Hide content immediately
                    content.style.display = 'none';
                });
                // Add active class to clicked button and corresponding content
                button.classList.add('active');
                // Find the corresponding content by index
                if (tabContents[buttonIndex]) {
                    var targetContent = tabContents[buttonIndex];
                    targetContent.classList.add('active');
                    // Show content first, then let CSS handle the opacity transition
                    targetContent.style.display = 'flex';
                    // Force reflow to ensure display: block is applied before transition
                    targetContent.offsetHeight;
                    // Remove inline opacity so CSS transition can work
                    targetContent.style.removeProperty('opacity');
                }
                else {
                    console.log('Tab content not found for index:', buttonIndex);
                }
            });
        });
        // Ensure first tab is active by default
        if (tabButtons.length > 0 && tabContents.length > 0) {
            tabButtons[0].classList.add('active');
            tabContents[0].classList.add('active');
        }
    });
}
